"use strict";
const _ = require('lodash');
const { FLAIVY_ORGANIZATION_IDS } = require('../organization');
const { calculateRequiresAlcoholPermit } = require('../article');
const statesAllowingDateChange = ['sentToSupplier', 'shipped'];
const ableToChangeDeliveryDate = purchaseOrder => _.includes(statesAllowingDateChange, purchaseOrder.purchaseOrderState);
const statesAllowingEdit = ['draft', 'waitingForFlaivyApproval'];
const ableToEdit = purchaseOrder => _.includes(statesAllowingEdit, purchaseOrder.purchaseOrderState);
const hasOwnedByDrycksProducts = purchaseOrder => {
    if (_.get(purchaseOrder, 'purchaseOrderRows.length', 0) === 0) {
        return false;
    }
    return !!purchaseOrder.purchaseOrderRows.find(x => _.includes(FLAIVY_ORGANIZATION_IDS, _.get(x, 'article.owningSupplierOrganizationId')));
};
const requiresEMCS = purchaseOrder => {
    if (_.get(purchaseOrder, 'purchaseOrderRows.length', 0) === 0) {
        return false;
    }
    return !!purchaseOrder.purchaseOrderRows.find(x => calculateRequiresAlcoholPermit(_.get(x, 'article.productCategory'), _.get(x, 'article.alcoholPercentage')));
};
const hasCopackArticles = purchaseOrder => {
    if (_.get(purchaseOrder, 'purchaseOrderRows.length', 0) === 0) {
        return false;
    }
    return purchaseOrder.purchaseOrderRows.some(x => _.get(x, 'article.onCopack', false));
};
module.exports = {
    ableToChangeDeliveryDate,
    ableToEdit,
    hasOwnedByDrycksProducts,
    hasCopackArticles,
    requiresEMCS,
};
